import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  page: number;
  totalPage?: number;
  setPage?: (page: number) => void;
}

export default function NextPrevious({ page, totalPage = 0, setPage = () => null }: Props) {
  const { t } = useTranslation();

  return (
    <nav className='flex flex-wrap items-center justify-center space-x-2 max-w-full'>
      <button
        disabled={page < 2}
        onClick={() => setPage(page - 1)}
        className='text-gray-500 hover:text-blue-600 p-4 inline-flex items-center gap-2 rounded-md cursor-pointer disabled:pointer-events-none disabled:opacity-50'
      >
        <i aria-hidden='true' className='icon-angle-left' />
        <span className='sr-only'>{t('Previous')}</span>
      </button>
      <button
        disabled={!!(totalPage && page + 1 > totalPage)}
        onClick={() => setPage(page + 1)}
        className='text-gray-500 hover:text-blue-600 p-4 inline-flex items-center gap-2 rounded-md cursor-pointer disabled:pointer-events-none disabled:opacity-50'
      >
        <span className='sr-only'>{t('Next')}</span>
        <i aria-hidden='true' className='icon-angle-right' />
      </button>
    </nav>
  );
}
